const queryKeys = {
  GET_WIDGET_SETTINGS: 'getWidgetSettings',
}

export default queryKeys
